import { createStore, del, get } from "idb-keyval";

import { STORAGE_KEYS } from "../app_constants";

import type {
  LibraryMigrationAdapter,
  LibraryPersistedData,
} from "@excalidraw/excalidraw/data/library";

/**
 * One-shot migration adapter: reads the legacy per-browser library from
 * IndexedDB (where it used to live) and feeds it into the new server-backed
 * adapter via the native useHandleLibrary migration flow.
 *
 * After the migration successfully completes, `clear()` is called by the
 * Excalidraw runtime — we then drop the old IDB store so the migration only
 * happens once per browser.
 *
 * Mirrors the keys previously used by LibraryIndexedDBAdapter in LocalData.ts.
 */
const LEGACY_IDB_KEY = "libraryData";
const LEGACY_IDB_NAME = STORAGE_KEYS.IDB_LIBRARY;

const legacyStore = createStore(
  `${LEGACY_IDB_NAME}-db`,
  `${LEGACY_IDB_NAME}-store`,
);

export const LibraryIDBMigrationAdapter: LibraryMigrationAdapter = {
  async load() {
    const data = await get<LibraryPersistedData>(LEGACY_IDB_KEY, legacyStore);
    return data ?? null;
  },

  async clear() {
    await del(LEGACY_IDB_KEY, legacyStore);
  },
};
